export default "__VITE_ASSET__CXDxs13O__"